import { Skeleton } from "@/app/components/shadcn/skeleton";
import PhoneInputSkeleton from "./PhoneInputSkeleton";

/**
 * LoginForm'un ilk adımının (telefon formu) iskeleti.
 *
 * login/page.tsx'te <Suspense fallback> olarak kullanılır: LoginForm useSearchParams()
 * kullandığından statik sayfada CSR bailout oluyor; fallback olmadan form alanı SSR'da
 * BOŞ kalıyordu ("başta gözükmüyor"). Bu iskelet o boşluğu doldurur ve PhoneInputSkeleton'ı
 * paylaştığı için LoginForm hydrate olup PhoneInput kendi skeleton'ını gösterdiğinde geçiş
 * görünmez olur (skeleton → skeleton → input).
 */
const AuthPhoneFormSkeleton = () => {
  return (
    <div className="space-y-6">
      <div className="grid gap-2">
        {/* "Telefon Numarası *" etiketi */}
        <Skeleton className="h-4 w-32" />
        <PhoneInputSkeleton className="h-12" />
      </div>
      {/* "Kod Gönder" butonu */}
      <Skeleton className="h-12 w-full rounded-md" />
    </div>
  );
};

export default AuthPhoneFormSkeleton;
